import { formatPriceToNumber, TCustomerCartProductItemExtend } from '@segway/core'
import Big from 'big.js'

/**
 * 生成购物车上报 GTM items 数据
 */
export const generateGTMCartItemsParams = (products: TCustomerCartProductItemExtend[]) => {
  const data = products.reduce<
    {
      item_id: string | null | undefined
      item_name: string | null | undefined
      item_brand: string | null | undefined
      item_list_name: string | null | undefined
      msrp: number | null | undefined
      price: number | null | undefined
      quantity: number | null | undefined
      item_category: string
      item_category2: string
      item_category3: string
      item_category4: string
      item_category5: string
    }[]
  >((result, item) => {
    if (item.rawProduct.__typename !== 'BundleCartItem') {
      const item_category = item.rawProduct.product.gtm_item_categories
        ? JSON.parse(item.rawProduct.product.gtm_item_categories)
        : {
            item_category: '',
            item_category2: '',
            item_category3: '',
            item_category4: '',
            item_category5: '',
          }

      result.push({
        item_id: item.rawProduct.product.sku,
        item_name: item.rawProduct.product.name,
        item_brand: 'Segway',
        item_list_name: 'cart',
        msrp: item.rawProduct.product.price_range.minimum_price.regular_price.value,
        price: item.rawProduct.product.price_range.minimum_price.final_price.value,
        quantity: item.quantity,
        ...item_category,
      })
    }

    if (item.rawProduct.__typename === 'BundleCartItem') {
      let bundleMainProductTotalPrice = 0
      const bundleMainProduct = item.rawProduct.bundle_options.find((option) => option?.required)
      const bundleOptions = item.rawProduct.bundle_options.filter((option) => !option?.required)

      const item_category = item.rawProduct.product.gtm_item_categories
        ? JSON.parse(item.rawProduct.product.gtm_item_categories)
        : {
            item_category: '',
            item_category2: '',
            item_category3: '',
            item_category4: '',
            item_category5: '',
          }

      if (bundleMainProduct) {
        bundleMainProductTotalPrice = bundleMainProduct?.values
          .reduce((total, option) => {
            total = total.plus(option?.price || 0)
            return total
          }, new Big(0))
          .toNumber()
      }

      result.push({
        item_id: item.rawProduct.product.sku,
        item_name: item.rawProduct.product.name,
        item_brand: 'Segway',
        item_list_name: 'cart',
        msrp: formatPriceToNumber(
          new Big(item.rawProduct.product.price_range.minimum_price.regular_price.value!)
            .plus(bundleMainProductTotalPrice)
            .toNumber(),
        ).numberValue,
        price: formatPriceToNumber(
          new Big(item.rawProduct.product.price_range.minimum_price.final_price.value!)
            .plus(bundleMainProductTotalPrice)
            .toNumber(),
        ).numberValue,
        quantity: item.quantity,
        ...item_category,
      })

      bundleOptions.forEach((option) => {
        option?.values.forEach((value) => {
          result.push({
            item_id: value?.sku,
            item_name: value?.label,
            item_brand: 'Segway',
            item_list_name: 'cart',
            msrp: formatPriceToNumber(value?.price || 0).numberValue,
            price: formatPriceToNumber(value?.price || 0).numberValue,
            quantity: item.quantity,
            // TODO: bundle 产品这里无法获取到数据
            item_category: '',
            item_category2: '',
            item_category3: '',
            item_category4: '',
            item_category5: '',
          })
        })
      })
    }

    return result
  }, [])

  return data
}
